export default function Pandas_Getting_Started() {
  return <div>Pandas_GettingStarted </div>;
}
